import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { LoaderService } from "app/infrastructure/services/loader.service";
import { environment } from "environments/environment";
import { CacheService } from "app/infrastructure/services/cache.service";

@Component({
    selector: 'sx-product-flow-preview',
    templateUrl: './flow-preview.component.html',
    styleUrls: ['./flow-preview.component.css']
})
export class FlowPreviewComponent implements OnInit {

    codProduct: string;
    flowId: number;
    flowUrl: SafeResourceUrl;
    loaded: boolean = false;
    constructor(
        private aRoute: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private loader: LoaderService,
        private cacheService: CacheService
    ) {

    }

    ngOnInit(): void {
        this.loader.mostrarLoader()
        let self = this
        this.aRoute.params.subscribe((params: Params) => {
            this.flowId = this.cacheService.getCurrentFlowId();
            this.codProduct = params['codproducto'];
            this.flowUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.b2bIframeUrl}/${this.codProduct}/${this.flowId}/preview`);

            function bindEvent(element, eventName, eventHandler) {
                if (element.addEventListener) {
                    element.addEventListener(eventName, eventHandler, false);
                } else if (element.attachEvent) {
                    element.attachEvent('on' + eventName, eventHandler);
                }
            }

            bindEvent(window, 'message', function (e) {
                if (e.data == "loaded") {
                    self.sendMessage({
                        name: 'getHeight',
                        value: null
                    })
                } else if (e.data == "getToken") {
                    self.sendMessage({
                        name: "token",
                        value: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im1hcnRpbkBiMmIuY29tIiwibmJmIjoxNTQ0ODAzNjMyLCJleHAiOjE1NDczOTU2MzIsImlhdCI6MTU0NDgwMzYzMiwiQ29udGV4dCI6IntcIlN5c0NvZGVcIjpcIkRFTU9cIixcIlRlbmFudENvZGVcIjpcIlBST1ZcIixcIlVzZXJcIjpcIm1hcnRpbkBiMmIuY29tXCIsXCJQcm9kQ29kZVwiOm51bGwsXCJMYW5nQ29kZVwiOlwiZW4tVVNcIn0ifQ.10QgbZkXotafrHDMCFX9VzxN8hPUZRodV2_nAlk3mVU"
                    })
                } else if (e.data.name && e.data.name == "height") {
                    self.setHeight(e.data.value)
                }
            });
        });
    }

    sendMessage(msg) {
        var iframeEl: HTMLIFrameElement = document.getElementById('iframe') as HTMLIFrameElement
        iframeEl.contentWindow.postMessage(msg, '*');
    }

    setHeight(height) {
        document.getElementById('flow-container').setAttribute("style", `height:${height}px`);
        document.getElementById('iframe').setAttribute("style", "height: 100%");
        document.getElementsByClassName('container-soc')[0].setAttribute("style", "padding-bottom:0");
        this.loader.ocultarLoader()
        this.loaded = true
    }

}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/flow-preview/flow-preview.component.ts